export default __webpack_public_path__ + "static/img-stickers-9fcdc6f307a561401936ab3abfc1c349.png";